import { render } from "./KTDataTable.vue?vue&type=template&id=40b7a35e&ts=true"
import script from "./KTDataTable.vue?vue&type=script&lang=ts"
export * from "./KTDataTable.vue?vue&type=script&lang=ts"

import "./KTDataTable.vue?vue&type=style&index=0&id=40b7a35e&lang=scss"

import exportComponent from "/var/www/tenanthub.au/runners/admin/root/tenanthub-admin/tenanthub-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__